<div class="container-fluid avacon-dis-order">
  <div class="row">
    <div class="col">
      <h1 class="header">
        <app-back-button [title]="'module.storungen.title' | translate" (backClicked)="gotoDashboard()"> </app-back-button>
      </h1>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <h2 class="title">
        {{ 'module.storungen.description' | translate }}
      </h2>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <h5 class="avacon-dis-order-description-title">
        {{ 'module.storungen.content.content1.title' | translate }}
      </h5>
      <h5 class="avacon-dis-order-description-title">
        {{ 'module.storungen.content.content1.number' | translate }}
      </h5>
      <p>
        {{ 'module.storungen.content.content1.description' | translate }}
      </p>
      <h5 class="avacon-dis-order-description-title">
        {{ 'module.storungen.content.content2.title' | translate }}
      </h5>
      <h5 class="avacon-dis-order-description-title">
        {{ 'module.storungen.content.content2.number' | translate }}
      </h5>
      <p>
        {{ 'module.storungen.content.content2.description1' | translate }}
      </p>
      <p>
        {{ 'module.storungen.content.content2.description2' | translate }}
      </p>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <h2 class="title">
        {{ 'module.storungen.subTitle' | translate }}
      </h2>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="embed-responsive embed-responsive-4by3 avacon-dis-orders-frame" *ngIf="!isIE11">
        <iframe title="storungen" class="embed-responsive-item" [src]="url"></iframe>
      </div>
      <img alt="warning-img" class="warning-message" src="./assets/images/ie11_storungen_message.png" *ngIf="isIE11" />
    </div>
  </div>
  <div class="row">
    <div class="col">
      <h4 class="avacon-dis-order-link-fault">
        {{ 'module.storungen.links.content1.title' | translate }}
        <a target="_blank" [href]="faultCardLink">
          {{ 'module.storungen.links.content1.text' | translate }}
        </a>
      </h4>
      <h4 class="avacon-dis-order-link-fault">
        {{ 'module.storungen.links.content2.title' | translate }}
        <a target="_blank" [href]="videoLink"> Video </a>
      </h4>
      <h2 class="title">
        {{ 'module.storungen.links.content3.title' | translate }}
      </h2>

      <div>
        <div (click)="toggleCollapse()" class="avacon-collapse-btn">
          {{ 'module.storungen.links.content3.button' | translate }}
          <img
            alt="collapse-arrow-img"
            [class]="isCollapsed ? 'avacon-arrow-collapse' : 'avacon-arrow-collapsed'"
            src="./assets/icons/ico_arrow_collapse.svg"
          />
        </div>

        <div [class]="isCollapsed ? 'avacon-collapsed' : 'avacon-collapse'">
          <ul class="avacon-dis-order-guide">
            <li>{{ 'module.storungen.links.content3.guide.text1' | translate }}</li>
            <li>{{ 'module.storungen.links.content3.guide.text2' | translate }}</li>
            <li>{{ 'module.storungen.links.content3.guide.text3' | translate }}</li>
            <li>{{ 'module.storungen.links.content3.guide.text4' | translate }}</li>
            <li>{{ 'module.storungen.links.content3.guide.text5' | translate }}</li>
            <li>{{ 'module.storungen.links.content3.guide.text6' | translate }}</li>
            <li>{{ 'module.storungen.links.content3.guide.text7' | translate }}</li>
            <li>{{ 'module.storungen.links.content3.guide.text8' | translate }}</li>
            <li>{{ 'module.storungen.links.content3.guide.text9' | translate }}</li>
            <li>{{ 'module.storungen.links.content3.guide.text10' | translate }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
